module.exports = __webpack_public_path__ + "img/fz_waterfix.296c3064.png";